'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.animate = undefined;

var _inViewport = require('in-viewport');

var _inViewport2 = _interopRequireDefault(_inViewport);

var _animations = require('./animations');

var animations = _interopRequireWildcard(_animations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var animate = exports.animate = function animate(animation, duration, iterations, element, handleAnimateFinnished) {
	var inViewportWatcher = (0, _inViewport2.default)(element, { failsafe: false, offset: 50 }, function () {
		animations[animation](element, iterations, parseInt(duration, 10));

		if (handleAnimateFinnished) {
			handleAnimateFinnished();
		}
	});

	return inViewportWatcher;
};